import { can, PERMS } from '../../utils/accessControl';

// Reasons offered when marking an item damaged. The API accepts any short text,
// so this list can change without a migration.
export const DAMAGE_REASONS = [
  'Stain',
  'Torn / hole',
  'Manufacturing defect',
  'Missing tag / label',
  'Other',
];

// Sending damages to the warehouse (and removing anyone's entry) is the
// "Send damages to warehouse" permission (Admin and Manager by default), as in api/damages.py.
export const canSendDamages = (user) => can(user, PERMS.DAMAGES_SEND);
